import React, { useEffect, useState, useRef } from "react";
import "../pagescss/GameBoard.css";
import SocketConnector from "../component.jsx/SocketConnector";
import Header from "../component.jsx/Header";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../component.jsx/apiConfig";
//
//
//

//
const GameBoard = () => {
  const [board, setBoard] = useState(Array(9).fill(null));
  const [currentPlayer, setCurrentPlayer] = useState(null);
  const [gameOver, setGameOver] = useState(false);
  const [waitingForOpponent, setWaitingForOpponent] = useState(false);
  const [timer, setTimer] = useState(25);
  const [timerActive, setTimerActive] = useState(false);
  const navigate = useNavigate();
  const socketRef = useRef(null); // Create a ref for the socket

  const gameId = localStorage.getItem("gameId");
  const player1Id = localStorage.getItem("no-msisdn");
  const player2Id = localStorage.getItem("player2Id");
  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    setCurrentPlayer(player1Id);
    handleMoveReceived();
  }, [player1Id]);

  useEffect(() => {
    if (gameOver) return; // Exit if the game is already over

    const winner = calculateWinner(board);

    if (winner) {
      setGameOver(true);
      const winnerId = winner === "X" ? player1Id : player2Id;
      localStorage.setItem("WinnerId", winnerId);

      // alert(winnerId === player1Id ? "Player 1 wins!" : "Player 2 wins!");

      if (winnerId === null) {
        // alert("Your opponent won the game!");
      } else {
        alert(winnerId === player1Id ? "You won the game!" : "Your opponent won the game!");
      }

      navigate("/");

      const postScore = async () => {
        const id = winnerId;
        const url = `${API_URL}/api/user/scores/${id}`;
        const score = 1;

        try {
          const response = await fetch(url, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ score }),
          });

          if (!response.ok) throw new Error("Failed to post score");
          await response.json();
        } catch (error) {
          console.error("Error posting score:", error);
          // alert("Your Apponent won the game!");
          navigate("/home");
        }
      };
      postScore(); // Trigger score post

    } else if (board.every((square) => square !== null)) {
      // Check for a draw
      setGameOver(true);
      alert("It's a draw!");
      navigate("/");
    }
  }, [board]);


  useEffect(() => {
    let interval = null;
    if (timerActive) {
      interval = setInterval(() => {
        setTimer((prev) => {
          if (prev === 1) {
            setWaitingForOpponent(false);
            setTimerActive(false);
            return 5;
          }
          return prev - 1;
        });
      }, 1000);
    } else if (!timerActive && timer !== 5) {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [timerActive, timer]);

  const handleSquareClick = async (index) => {
    if (board[index] || gameOver || waitingForOpponent) return;

    const updatedBoard = [...board];
    const symbol = currentPlayer === player1Id ? "X" : "O";
    updatedBoard[index] = symbol;

    setBoard(updatedBoard);
    await storeMove(gameId, currentPlayer, index);
    notifyOpponentMove(index, currentPlayer);

    setWaitingForOpponent(true);
    setTimerActive(true);
  };

  const notifyOpponentMove = (movePosition, playerId) => {
    if (socketRef.current) {
      const message = JSON.stringify({
        gameId,
        type: "newMove",
        move: { movePosition, playerId },
      });
      console.log("Sending message:", message); // Log the message being sent
      socketRef.current.send(message);
    } else {
      console.error("Socket is not connected.");
    }
  };

  const calculateWinner = (squares) => {
    const lines = [
      [0, 1, 2],
      [3, 4, 5],
      [6, 7, 8],
      [0, 3, 6],
      [1, 4, 7],
      [2, 5, 8],
      [0, 4, 8],
      [2, 4, 6],
    ];
    for (let line of lines) {
      const [a, b, c] = line;
      if (
        squares[a] &&
        squares[a] === squares[b] &&
        squares[a] === squares[c]
      ) {
        return squares[a];
      }
    }
    return null;
  };

  const storeMove = async (gameId, currentPlayer, movePosition) => {
    const playerId = JSON.parse(localStorage.getItem("no-msisdn"));
    try {
      const url = `${API_URL}/api/games/move/${gameId}/${playerId}/${movePosition}`;
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (!response.ok) {
        throw new Error("Failed to store move");
      }
    } catch (error) {
      console.error("Error storing move:", error);
      alert("Error storing move, please try again");
    }
  };

  const handleMoveReceived = (movePosition, playerId) => {
    setBoard((prevBoard) => {
      const updatedBoard = [...prevBoard];
      const symbol = playerId === player1Id ? "X" : "O";
      updatedBoard[movePosition] = symbol;
      return updatedBoard;
    });
    setWaitingForOpponent(false);
    setTimerActive(false);
    setCurrentPlayer(playerId === player1Id ? player2Id : player1Id);
  };

  const handleGameUpdate = (gameState) => {
    const mappedBoard = gameState.board.map((position) =>
      position === player1Id ? "X" : position === player2Id ? "O" : null
    );
    setBoard(mappedBoard);
    setCurrentPlayer(gameState.currentPlayer);
    setWaitingForOpponent(gameState.currentPlayer !== currentPlayer);
  };

  const renderSquare = (index) => {
    return (
      <button className="square" onClick={() => handleSquareClick(index)}>
        {board[index] ? board[index] : <img className="logo-gamenow-placeholder" src="https://casual.gamenow.com.pk/assets/images/logo%20(1).png" alt="Game-Now"></img>}
      </button>
    );
  };

  const handleBack = () => {
    navigate("/");
  };

  return (
    <div className="container-game">
      <Header />
      <div className="game-board-container">
        {/* <h2>Tic Tac Toe</h2> */}
        <div className="game-board">
          {Array(9)
            .fill(null)
            .map((_, index) => renderSquare(index))}
        </div>
        {waitingForOpponent && (
          <p>Waiting for opponent... {timer} seconds remaining</p>
        )}
        <button className="back-button" onClick={handleBack}>
          Back to Home
        </button>

        {/* Pass the socketRef to the SocketConnector */}
        <SocketConnector
          gameId={gameId}
          user={user}
          onMoveReceived={handleMoveReceived}
          onGameUpdate={handleGameUpdate}
          socketRef={socketRef} // Pass the ref here
        />
      </div>
    </div>
  );
};

export default GameBoard;
